import { ROUTE_PROFILE_ACHIEVEMENTS } from "@/constants/routes";
import { createRouteFromParams } from "@/src/helpers/createRouteWithParams";
import { IconButton } from "nvs-design-system/dist/IconButton";
import { Expand } from "nvs-ds-icons";
import Link from "next/link";
import Image from "next/image";
import { useAchievementStore } from "../../routes/achievements/components/AchievementsInterface/hooks";
import { UserAchievements } from "../../routes/achievements/types";
import { useAchievementsClicked } from "../../routes/achievements/hooks/analyticsHooks";

type Props = {
  userAchievements?: UserAchievements;
  swooshHandle: string;
};

const Achievements: React.FC<Props> = ({ userAchievements, swooshHandle }) => {
  const achievementsClicked = useAchievementsClicked();

  const showAchievementDetails = useAchievementStore(
    (state) => state.showAchievementDetails,
  );
  const hideAchievementDetails = useAchievementStore(
    (state) => state.hideAchievementDetails,
  );
  const achievementRoute = createRouteFromParams(ROUTE_PROFILE_ACHIEVEMENTS, {
    handle: swooshHandle,
  });

  return (
    <div className="flex flex-wrap gap-[18px]">
      {userAchievements?.achievements.map((achievement) => (
        <Link
          onClick={() => {
            achievementsClicked({});
            showAchievementDetails(achievement.achievementCategoryId);
          }}
          href={achievementRoute}
          key={achievement.name}
        >
          <Image
            src={achievement.image}
            alt={achievement.name}
            width={46}
            height={46}
          />
        </Link>
      ))}
      <Link
        onClick={() => {
          achievementsClicked({});
          hideAchievementDetails();
        }}
        href={achievementRoute}
      >
        <IconButton aria-label="Navigate to your achievements page">
          <Expand />
        </IconButton>
      </Link>
    </div>
  );
};

export default Achievements;
